import React from 'react';
import styles from './App.module.scss';

import CTACard from './components/CTACard';
import { useGoogleMapsApi } from './api/gis';
import { REDIRECT_URL, categoryProduct, productPageName } from './api/portletConfiguration';
import { setCookie } from './utils/InputParamsProvider';
import Loading from './components/Loading';

export default function App() {
	useGoogleMapsApi();

	const [loading, setLoading] = React.useState(false);

	React.useEffect(() => {
		console.log("AXA Product: " + categoryProduct);
		if (categoryProduct) {
			setCookie('axa-product', categoryProduct, 1);
		}

		console.log("AXA Product Page: " + productPageName);
		if (productPageName) {
			setCookie('page-product', productPageName, 1);
		}
	}, []);

	function handleSearchSubmit({ lat, lng, formattedAddress }) {
		setCookie('lat', lat, 1);
		setCookie('lng', lng, 1);
		setCookie('formattedAddress', formattedAddress, 1);
		setCookie('axa-product', categoryProduct, 1);
		setCookie('page-product', productPageName, 1);
		console.log(REDIRECT_URL);
		window.location.href = REDIRECT_URL;
	}

	return (
		<div className={styles.root}>
			<Splash />
			<CTACard onSearchSubmit={handleSearchSubmit} />
			{loading ? <Loading /> : null}
		</div>
	);
}

function Splash() {
	return <div className={styles.splash}></div>;
}